import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { useState } from "react";
import { toFixed } from "src/services/utils";
import BaseOption from "../components/BaseOption";
import FigureText from "../components/FigureText";
import InterestRateStrategyDialog from "./InterestRateStrategyDialog";

export default function InterestRateStrategy({ asset, ...props }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only("xs"));
  const [open, setOpen] = useState(false);

  function onBaseButOptionClick() {
    setOpen(true);
  }

  return (
    <>
      <BaseOption butProps={{ onClick: onBaseButOptionClick }} {...props}>
        <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Utilization Optimal"
            value={`${asset.utilizationOptimal * 100}%`}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Slope 1"
            value={`${toFixed(asset.slope1 * 100, 2)}%`}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Slope 2"
            value={`${asset.slope2 * 100}%`}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
          <FigureText
            sx={{ display: "flex", alignItems: "baseline" }}
            title="Base Interest Rate"
            value={`${asset.baseBorrowRate * 100}%`}
            mr={matches ? 0 : 8}
            justifyContent={matches ? "space-between" : "flex-start"}
            width={matches ? "100%" : "inherit"}
          />
        </Box>
      </BaseOption>
      <InterestRateStrategyDialog asset={asset} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
